<script>
	import { beforeUpdate } from "svelte";
	import Item from "./Item.svelte";
	export let items;
	export let id;
	export let type;
	export let horizontal;
	export let feed;

	let classes = []
	if(horizontal) {
		classes.push('list-group-horizontal')
	} else {
		classes.push('list-group-flush')
	}

	if(feed) {
	$: fetch(``+feed)
		.then(r => r.json())
		.then(data => {
			console.log(data)
			//items = data.data.children;

			items = []
			data.data.children.forEach((item, i) => {
				items.push( item.data )
			});


			//window.scrollTo(0, 0);
		});
		}
</script>

<div id="{id}" class="type-{type}">

<slot></slot>

{#if items}


	{#if type != "button"}
		<ul class="list-group {classes}" id="{id}">
			

			{#each items as item, i}
				<Item {item} {i} {type} parent_id={id}/>
			{/each}

	</ul>
	{:else}
	{#each items as item, i}
		<Item {item} {i} {type} parent_id={id}/>
	{/each}
	{/if}

{:else}
	<p class="loading">loading...</p>
{/if}

</div>
<br /><br />

<style>
	a {
		padding: 2em;
		display: block;
	}

	.loading {
		opacity: 0;
		animation: 0.4s 0.8s forwards fade-in;
	}

	@keyframes fade-in {
		from { opacity: 0; }
		to { opacity: 1; }
	}
</style>
